import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../store/auth.store';
import { LOCAL_STORAGE_REDIRECT_URL } from '../constants';

export const primaryAuthGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Don't redirect for 404 routes
  if (route.routeConfig?.path === '**') return true;

  if (authStore.user()) return true;
  // Store the URL the user was trying to access
  localStorage.setItem(LOCAL_STORAGE_REDIRECT_URL, state.url);
  router.navigate(['/login']);

  return false;
};
